import { AxiosError, AxiosResponse } from 'axios';

import { ApiPortfolio } from 'dashboard/models/ApiPortfolio';
import Config from '../../shared/config';
import dayjs from 'dayjs';
import useSWR from 'swr';

export function usePortfolio(
  userkey: number,
  modulekey: number,
  layer: number
) {
  const {
    isLoading,
    data: response,
    error
  } = useSWR<AxiosResponse<ApiPortfolio>, AxiosError<Error>>(
    userkey && modulekey && !isNaN(layer)
      ? `${Config.API}/api/portfolio/list/portfolio/user/${userkey}/module/${modulekey}/layer/${layer}`
      : null
  );

  return {
    loadingPortfolio: isLoading,
    loadPortfolioError: error,
    portfolio:
      error?.code === '404' || !response
        ? null
        : {
            ...response.data,
            created: dayjs(response.data.created).toDate(),
            modified: dayjs(response.data.modified).toDate()
          }
  };
}
